import React from "react";
import { Link } from "react-router-dom";
import styles from "./TabButtons.module.css";

const TabButtons = ({ tab, region, summonerName }) => {
  return (
    <div className={styles.buttons}>
      <div className={tab === 0 ? styles.active : ""}>
        <Link to={{ pathname: `/${summonerName}` }}>Overview</Link>
      </div>
      <div className={tab === 1 ? styles.active : ""}>
        <Link to={{ pathname: `/${summonerName}/live` }}>Live</Link>
      </div>
    </div>
  );
};
export default TabButtons;
